import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=3d33fb8e&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"
import style0 from "./Copy.vue?vue&type=style&index=0&id=3d33fb8e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33fb8e",
  null
  
)

export default component.exports